import { BENEFITS } from "@/data/content";
import { Reveal, SectionLabel } from "@/components/landing/shared";

export const Benefits = () => (
  <section className="border-t border-zinc-900 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <SectionLabel index="04" testid="benefits-label">
          Why Flownavy
        </SectionLabel>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold leading-none tracking-tight sm:text-5xl">
          Everything an agency charges for — stripped out.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-zinc-900 bg-zinc-900 sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08}>
            <div
              className="h-full bg-[#0a0a0a] p-8"
              data-testid={`benefit-${i}`}
            >
              <span className="ff-mono text-xs text-[#C7FF3C]">0{i + 1}</span>
              <h3 className="mt-5 text-lg font-semibold tracking-tight">{b.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-500">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
